module.exports = __webpack_public_path__ + "static/media/yusuf-1.39e45bfd.jpg";